import React, { InputHTMLAttributes } from 'react'
import { Button } from '@mindfulchefuk/design-system/Button/Button'
import { HiddenInput } from '@mindfulchefuk/design-system/Forms/form.styles'
import { useRadio } from './useRadio'

type TRadioButton = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'checked'
> & { 'data-testid'?: string }

/** @deprecated this should no longer be used as it's not in the design system - try RadioBox instead  */
export const RadioAsButton = ({
  children,
  value,
  'data-testid': testId,
  ...rest
}: TRadioButton) => {
  const [labelProps, inputProps] = useRadio(value)

  return (
    <Button
      as="label"
      type="button"
      variant="secondary"
      size="large"
      data-testid={`${testId}-label`}
      {...labelProps}
    >
      <HiddenInput
        type="radio"
        {...inputProps}
        {...rest}
        data-testid={testId}
      />
      {children}
    </Button>
  )
}
